const AUTH_CLIENT_DATA_CONFIG = {
  REDIRECT_URI: import.meta.env.VITE_REDIRECT_URL ?? '',
  CLIENT_AUTHORIZATION_TOKEN: import.meta.env.VITE_ACCOUNTS_CLIENT_TOKEN ?? '',
};

export { AUTH_CLIENT_DATA_CONFIG };
